import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "../config/site";

function upsertMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const m = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/**
 * Per-route SEO: title, meta description, canonical, Open Graph and Twitter
 * tags. noindex marks driver-facing/owner utility pages out of search results.
 */
export default function Seo({ title, description, noindex = false }) {
  const { pathname } = useLocation();
  const canonicalPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "") + "/";

  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${SITE.name}`
      : `${SITE.name} — Essex ↔ London £100 Fixed Fare`;
    const url = `https://${SITE.domain}${canonicalPath}`;

    document.title = fullTitle;
    if (description) {
      upsertMeta('meta[name="description"]', "content", description);
    }
    upsertMeta('meta[name="robots"]', "content",
      noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    upsertMeta('meta[property="og:title"]', "content", fullTitle);
    if (description) upsertMeta('meta[property="og:description"]', "content", description);
    upsertMeta('meta[property="og:url"]', "content", url);
    upsertMeta('meta[name="twitter:title"]', "content", fullTitle);
    if (description) upsertMeta('meta[name="twitter:description"]', "content", description);
  }, [title, description, noindex, canonicalPath]);
  return null;
}
